import { action, createRequestTypes } from 'utils/actions'

export const ENTITIES_EVENT_GROUP = createRequestTypes('ENTITIES_EVENT_GROUP')

export const eventGroup = {
  request: eventGroupId => action(ENTITIES_EVENT_GROUP.REQUEST, { eventGroupId }),
  success: (eventGroupId, response) => action(ENTITIES_EVENT_GROUP.SUCCESS, { eventGroupId, response }),
  failure: (eventGroupId, error) => action(ENTITIES_EVENT_GROUP.FAILURE, { eventGroupId, error }),
}

export const ENTITIES_EVENT_GROUPS = createRequestTypes('ENTITIES_EVENT_GROUPS')

export const eventGroups = {
  request: partnerId => action(ENTITIES_EVENT_GROUPS.REQUEST, { partnerId }),
  success: (partnerId, response) => action(ENTITIES_EVENT_GROUPS.SUCCESS, { partnerId, response }),
  failure: (partnerId, error) => action(ENTITIES_EVENT_GROUPS.FAILURE, { partnerId, error }),
}

export const ENTITIES_EVENT_GROUP_PERFORMANCES = createRequestTypes('ENTITIES_EVENT_GROUP_PERFORMANCES')

export const eventGroupPerformances = {
  request: eventGroupId => action(ENTITIES_EVENT_GROUP_PERFORMANCES.REQUEST, { eventGroupId }),
  success: (eventGroupId, response) => action(ENTITIES_EVENT_GROUP_PERFORMANCES.SUCCESS, { eventGroupId, response }),
  failure: (eventGroupId, error) => action(ENTITIES_EVENT_GROUP_PERFORMANCES.FAILURE, { eventGroupId, error }),
}

export const ENTITIES_EVENT_GROUP_PAST_PERFORMANCES = createRequestTypes('ENTITIES_EVENT_GROUP_PAST_PERFORMANCES')

export const eventGroupPastPerformances = {
  request: eventGroupId =>
    action(ENTITIES_EVENT_GROUP_PAST_PERFORMANCES.REQUEST, { eventGroupId }),
  success: (eventGroupId, response) =>
    action(ENTITIES_EVENT_GROUP_PAST_PERFORMANCES.SUCCESS, { eventGroupId, response }),
  failure: (eventGroupId, error) =>
    action(ENTITIES_EVENT_GROUP_PAST_PERFORMANCES.FAILURE, { eventGroupId, error }),
}

export const ENTITIES_EVENT_GROUP_DEALS = createRequestTypes('ENTITIES_EVENT_GROUP_DEALS')

export const eventGroupDeals = {
  request: eventGroupId =>
    action(ENTITIES_EVENT_GROUP_DEALS.REQUEST, { eventGroupId }),
  success: (eventGroupId, response) =>
    action(ENTITIES_EVENT_GROUP_DEALS.SUCCESS, { eventGroupId, response }),
  failure: (eventGroupId, error) =>
    action(ENTITIES_EVENT_GROUP_DEALS.FAILURE, { eventGroupId, error }),
}

export const ENTITIES_EVENT_GROUP_SELLABLE_ITEMS = createRequestTypes('ENTITIES_EVENT_GROUP_SELLABLE_ITEMS')

export const eventGroupSellableItems = {
  request: eventGroupId =>
    action(ENTITIES_EVENT_GROUP_SELLABLE_ITEMS.REQUEST, { eventGroupId }),
  success: (eventGroupId, response) =>
    action(ENTITIES_EVENT_GROUP_SELLABLE_ITEMS.SUCCESS, { eventGroupId, response }),
  failure: (eventGroupId, error) =>
    action(ENTITIES_EVENT_GROUP_SELLABLE_ITEMS.FAILURE, { eventGroupId, error }),
}

export const ENTITIES_EVENT_GROUP_SELLABLE_ITEM_GROUPS = createRequestTypes('ENTITIES_EVENT_GROUP_SELLABLE_ITEM_GROUPS')

export const eventGroupSellableItemGroups = {
  request: eventGroupId =>
    action(ENTITIES_EVENT_GROUP_SELLABLE_ITEM_GROUPS.REQUEST, { eventGroupId }),
  success: (eventGroupId, response) =>
    action(ENTITIES_EVENT_GROUP_SELLABLE_ITEM_GROUPS.SUCCESS, { eventGroupId, response }),
  failure: (eventGroupId, error) =>
    action(ENTITIES_EVENT_GROUP_SELLABLE_ITEM_GROUPS.FAILURE, { eventGroupId, error }),
}



/** WEBPACK FOOTER **
 ** ./src/actions/entities/event-groups/event-groups-actions.js
 **/